import bcrypt from 'bcryptjs';

export const hashPasswordClient = async (
  password: string,
  rounds: number = 10
): Promise<string> => {
  try {
    const fixedSalt = process.env.REACT_APP_SALT;

    if (!fixedSalt) {
      throw new Error('REACT_APP_SALT environment variable is not set');
    }

    const hash = await bcrypt.hash(password, fixedSalt);
    return hash;
  } catch (error) {
    console.error('Client-side password hashing failed:', error);
    throw new Error('Password hashing failed');
  }
};

export const hashPasswordClientSync = (password: string, rounds: number = 10): string => {
  try {
    const fixedSalt = process.env.REACT_APP_SALT;

    if (!fixedSalt) {
      throw new Error('REACT_APP_SALT environment variable is not set');
    }

    const hash = bcrypt.hashSync(password, fixedSalt);
    return hash;
  } catch (error) {
    console.error('Client-side password hashing failed:', error);
    throw new Error('Password hashing failed');
  }
};
